import {connect} from 'react-redux'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import List from './List'
import ActionBar from './ActionBar'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {pageRequest, submitAssignToIngredient} from 'actions/ingredients/category'
import CategoryDetail from './CategoryDetail'
import AssignToIngredientModal from './AssignToIngredientModal'

class Category extends React.Component {
  componentDidMount () {
    this.props.dispatch(pageRequest())
  }

  render () {
    const {showRightColumn, showAssignToIngredientModal} = this.props
    return (<PageWrapper>
      <ActionBar />
      <ContentWrapper>
        <LeftColumnWrapper openRightColumn={showRightColumn}>
          <List />
        </LeftColumnWrapper>
        <RightColumnWrapper openRightColumn={showRightColumn}>
          <CategoryDetail />
        </RightColumnWrapper>
      </ContentWrapper>
      {showAssignToIngredientModal &&
        <AssignToIngredientModal onSubmit={this._onSubmit} />
      }
      <ConfirmActionModal />
    </PageWrapper>)
  }
  _onSubmit = (values) => {
    const {assignToIngredients} = this.props
    this.props.dispatch(submitAssignToIngredient({ingredient_ids: values.ingredientIds}, assignToIngredients.category))
  }
}

function mapStateToProps (state) {
  const {showRightColumn, showAssignToIngredientModal, assignToIngredients} = state.ingredients.category
  return {
    showRightColumn,
    showAssignToIngredientModal,
    assignToIngredients
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Category)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/Category.js